var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36 6H12a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V12a6 6 0 0 0-6-6Zm-24 4h24a2 2 0 0 1 2 2v16.72l-6.4-5.46a5.54 5.54 0 0 0-7.04 0L10 35.4V12a2 2 0 0 1 2-2Zm24 28H13.12l14-11.68a1.56 1.56 0 0 1 1.86 0L38 34v2a2 2 0 0 1-2 2Z",
  fill: "#9D9D9D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  fill: "#9D9D9D"
})));
export default SvgProductPlaceholder;